import api from './api';

export type DateRange = 'this_week' | 'this_month' | 'last_3_months' | 'last_6_months' | 'this_year' | 'all_time';

export interface TechnicianPerformance {
    user: {
        id: number;
        name: string;
    };
    open: number;
    closed: number;
    total: number;
}

export interface ManagerStatsResponse {
    technician_performance: TechnicianPerformance[];
}

export const getManagerStats = (userIds: number[], dateRange: DateRange | { start_date: string; end_date: string }) => {
    // Convert array to query parameters
    const userParams = userIds.map(id => `user_ids[]=${id}`).join('&');
    
    let dateParams = '';
    if (typeof dateRange === 'string') {
        // Predefined date range
        dateParams = `date_range=${dateRange}`;
    } else {
        // Custom date range
        dateParams = `start_date=${dateRange.start_date}&end_date=${dateRange.end_date}`;
    }
    
    return api.get<ManagerStatsResponse>(`/dashboard/manager-stats?${dateParams}&${userParams}`);
}; 

export interface OverviewStoreRow {
    id: number;
    name: string;
    storenumber?: string;
    store_email?: string;
    open: number;
    closed: number;
    total: number;
}

export interface OverviewCoachSummary {
    id: number;
    name: string;
    summary: { total: number; open: number; closed: number };
}

export interface OverviewResponse {
    success: boolean;
    data: {
        summary: { total: number; open: number; closed: number };
        regional_coaches: OverviewCoachSummary[];
        area_coaches: OverviewCoachSummary[];
        stores: OverviewStoreRow[];
    };
}

export const getDashboardOverview = (params: { start_date?: string; end_date?: string; regional_id?: number; area_id?: number }) => {
    const queryParts: string[] = [];
    if (params.start_date) queryParts.push(`start_date=${encodeURIComponent(params.start_date)}`);
    if (params.end_date) queryParts.push(`end_date=${encodeURIComponent(params.end_date)}`);
    if (params.regional_id) queryParts.push(`regional_id=${params.regional_id}`);
    if (params.area_id) queryParts.push(`area_id=${params.area_id}`);
    const query = queryParts.length ? `?${queryParts.join('&')}` : '';
    return api.get<OverviewResponse>(`/dashboard/overview${query}`);
};